import { Component, OnInit } from "@angular/core";
import { DataService_RoomSetup } from "../shared/data.service";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { RoomModifyRequest } from "../shared/room-modify-request";

@Component({
	selector: "app-add-room",
	templateUrl: "./add-room.component.html",
	styleUrls: ["./add-room.component.css"],
})
export class AddRoomComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private dataService: DataService_RoomSetup,
		private confirmationService: ConfirmationService
	) {}
	ngOnInit(): void {
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SchoolName = this.SelectedSchool.SchoolFullName;
	}

	////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////

	RoomNo: string = "";
	RoomDesc: string = "";
	SelectedSchool: any;
	SchoolName: string = "";

	Processing: boolean = false;
	errorMessage: string = "";

	////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.RoomNo == undefined || this.RoomNo == "") {
			this.errorMessage = "Enter a Room Number";
			return;
		}
		if (this.RoomDesc == undefined || this.RoomDesc == "") {
			this.errorMessage = "Enter a Description";
			return;
		}

		this.Processing = true;

		var parms: RoomModifyRequest = {
			RoomID: -1,
			SchoolID: this.SelectedSchool.SchoolID,
			RoomNo: this.RoomNo,
			RoomDesc: this.RoomDesc,
		};

		var result = this.dataService.RoomInsert(parms);
		result.subscribe(
			(response: any) => {
				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "roomadd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Room was added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "roomadd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Room: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	////////////////////////////////////////////////////////////////
}
